import checkBoxResponse_icon from "../../../Assets/checkBoxResponse_icon.svg";
import singleChoiceIcon from "../../../Assets/singleChoiceIcon.svg";
import MultiResponse_icon from "../../../Assets/MultiResponse_icon.svg";
import email_icon_Form from "../../../Assets/email_icon_Form.svg";
import responcechoice_icon from "../../../Assets/responcechoice_icon.svg";
import Website_Link from "../../../Assets/Website_Link.svg";
import minusIcon_spinner from "../../../Assets/minusIcon_spinner.svg";
import plusIcon_spinner from "../../../Assets/plusIcon_spinner.svg";
import documentresponse_icon from "../../../Assets/documentresponse_icon.svg";
import axios from "axios";
const ShortAnswer = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="table-view_shortAnswer">{question.answer}</div>
    </div>
  );
};

const ParagraphAnswer = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="table-view_shortAnswer">{question.answer}</div>
    </div>
  );
};

const Name = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="individual_nameAns_container">
        <div className="Name">
          {question.answer.firstName
            ? question.answer.firstName
            : "No Responses"}
        </div>
        <div className="Name">
          {question.answer.lastName ? question.answer.lastName : "No Responses"}
        </div>
      </div>
    </div>
  );
};

const Phone = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="nameAns_container">
        <div className="individual_Phone">
          <p>+91</p>
          {question.answer}
        </div>
      </div>
    </div>
  );
};

const MultipleChoice = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: question.question }}
        ></div>
      </div>
      {/* {response.responses.map((answer, i) => (
      ))} */}
      {/* <div className="Answer_container" key={i}> */}
      {/* <div className="responceCount">Response {i + 1}</div> */}
      <div className="chose_AnswerText">
        <img src={checkBoxResponse_icon} alt="checkBoxResponse_icon" />
        {question.answer}
      </div>
      {/* {i !== response.responses.length - 1 && <hr />} */}
      {/* </div> */}
    </div>
  );
};

const CheckBox = ({ question, index }) => {
  console.log(question);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>

      <div className="Answer_container">
        <div className="choice_AnswerText">
          {question.answer.map((text, i) => (
            <div
              style={{
                display: "flex",
                gap: "0.625rem",
              }}
              key={i}
            >
              <img src={MultiResponse_icon} alt="MultiResponse_icon" />
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Email = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: question.question }}
        ></div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="AnswerText" style={{ padding: "0.3rem 0" }}>
            <p className="TextWPic" style={{ backgroundColor: "transparent" }}>
              <img src={email_icon_Form} alt="email_icon_Form" />
              {question.answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Number = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: question.question }}
        ></div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="NameQuestion">
            <p>{question.answer}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const LineScale = ({ question, index }) => {
  console.log(question);
  const divs = [];

  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: question.question }}
        ></div>
      </div>

      <div className="Answer_container">
        <div className="chose_AnswerText">
          <img src={checkBoxResponse_icon} alt="checkBoxResponse_icon" />
          {question.answer}
        </div>
      </div>
    </div>
  );
};

const DateQuestion = ({ question, index }) => {
  // Function to format date
  const formatDate = (dateString, format) => {
    // Split the input date and format strings
    const dateParts = dateString.split("-");
    const formatParts =
      format === "" ? "year-month-date".split("-") : format.split("-");
    console.log(dateParts, formatParts, format);
    // Map the parts to their respective names
    const day = dateParts[formatParts.indexOf("date")];
    const month = dateParts[formatParts.indexOf("month")];
    const year = dateParts[formatParts.indexOf("year")];

    return { day, month, year };
  };

  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="datetime_container">
            <div className="appDate-container">
              <div className="date-container">
                <div key={index} className="date-item">
                  <div className="day">
                    {formatDate(question.answer, question.dateFormat).day}
                  </div>
                </div>
              </div>
              <div className="vertical-line"></div>
              <div className="month-year-container">
                <div key={index} className="time-container">
                  {formatDate(question.answer, question.dateFormat).month}/
                  {formatDate(question.answer, question.dateFormat).year}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const GridBox = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>

      <div>
        <table>
          <tbody>
            {question.answer?.map((value) => (
              <tr style={{ height: "3rem" }}>
                <td
                  style={{
                    background: "rgba(237, 241, 249, 1)",
                    border: "1px solid rgba(211, 220, 229, 1)",
                    padding: "0.2rem 1rem",
                    textAlign: "start",
                    color: "rgba(27, 36, 54, 1)",
                    fontFamily: "EuclidSemiBold",
                  }}
                >
                  {value.rowText}
                </td>
                <td
                  style={{
                    background: "rgba(27, 81, 187, 0.04)",
                    border: "1px solid rgba(211, 220, 229, 1)",
                    padding: "0.2rem 1rem",
                    textAlign: "start",
                    color: "rgba(27, 36, 54, 1)",
                    fontFamily: "EuclidSemiBold",
                  }}
                >
                  {value.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const CheckBoxGrid = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>

      <div>
        <table>
          <tbody>
            {question.answer?.map((value) => (
              <tr style={{ height: "3rem" }}>
                <td
                  style={{
                    background: "rgba(237, 241, 249, 1)",
                    border: "1px solid rgba(211, 220, 229, 1)",
                    padding: "0.2rem 1rem",
                    textAlign: "start",
                    color: "rgba(27, 36, 54, 1)",
                    fontFamily: "EuclidSemiBold",
                  }}
                >
                  {value.rowText}
                </td>
                <td
                  style={{
                    background: "rgba(27, 81, 187, 0.04)",
                    border: "1px solid rgba(211, 220, 229, 1)",
                    padding: "0.2rem 1rem",
                    textAlign: "start",
                    color: "rgba(27, 36, 54, 1)",
                    fontFamily: "EuclidSemiBold",
                  }}
                >
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    {value.values.map((value, i) => (
                      <p>{value},</p>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const DateAndTime = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="datetime_container">
            <div className="appDate-container">
              <div className="date-container">
                <div key={index} className="dateandtime-container">
                  {/* {console.log(answer.answer)} */}
                  <div className="">{question.answer.date}</div>
                </div>
              </div>
              <div className="vertical-line"></div>
              <div className="month-year-container">
                <div key={index} className="time-container">
                  <div className="time_container">{question.answer.time}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Website = ({ question, index }) => {
  console.log(question);
  const formatUrl = (url) => {
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="AnswerText">
            <p className="TextWPic">
              <img src={Website_Link} alt="Website_Link" />
              {question.answer === "No Responses" ? (
                <p>No Responses</p>
              ) : (
                <a
                  href={formatUrl(question.answer)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="website_link"
                >
                  {question.answer}
                </a>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Spinner = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: question.question }}
        ></div>
      </div>
      <div className="nameAns_container">
        <div
          className="Name"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "0.6rem",
          }}
        >
          <img src={minusIcon_spinner} alt="minusIcon_spinner" />
          {/* <p sty>{question.answer}</p> */}
          <img src={plusIcon_spinner} alt="plusIcon_spinner" />
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="NameQuestion">
            <p>{question.answer}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Dropdown = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      <div className="table-view_shortAnswer">{question.answer}</div>
    </div>
  );
};

const Signature = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: question.question }}
        ></div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        <div className="Answer_container">
          <div className="AnswerText">
            <p className="TextWPic">
              {question.answer === "No Responses" ? (
                <p>No Responses</p>
              ) : (
                <img src={question.answer} alt="email_icon_Form" />
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const VAFileUpload = ({ question, index }) => {
  const handleGetFile = async (fileKey) => {
    const Url = process.env.REACT_APP_API;
    console.log(fileKey);
    try {
      // Replace this with your actual API endpoint to get the signed URL
      const response = await axios.post(`${Url}/forms/retrieve`, { fileKey });

      console.log(response.data);
      if (response.data.success) {
        // Trigger the download
        const downloadUrl = response.data.url;
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileKey.split("/").pop(); // Set the download filename
        a.click();
      } else {
        alert("Failed to fetch the file URL.");
      }
    } catch (error) {
      console.error("Error getting signed URL", error);
    }
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>

      <div className="Answer_container">
        <div className="choice_AnswerText">
          {question.answer.map((text, i) => (
            <div
              style={{
                display: "flex",
                gap: "0.625rem",
              }}
              key={i}
              onClick={() => handleGetFile(text[0].fileKey)}
            >
              <img src={documentresponse_icon} alt="documentresponse_icon" />
              <p>{text[0].fileName}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Document = ({ question, index }) => {
  const handleGetFile = async (fileKey) => {
    const Url = process.env.REACT_APP_API;
    console.log(fileKey);
    try {
      // Replace this with your actual API endpoint to get the signed URL
      const response = await axios.post(`${Url}/forms/retrieve`, { fileKey });

      console.log(response.data);
      if (response.data.success) {
        // Trigger the download
        const downloadUrl = response.data.url;
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileKey.split("/").pop(); // Set the download filename
        a.click();
      } else {
        alert("Failed to fetch the file URL.");
      }
    } catch (error) {
      console.error("Error getting signed URL", error);
    }
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>

      <div className="Answer_container">
        <div className="choice_AnswerText">
          {question.answer.map((text, i) => (
            <div
              style={{
                display: "flex",
                gap: "0.625rem",
              }}
              key={i}
              onClick={() => handleGetFile(text[0].fileKey)}
            >
              <img src={documentresponse_icon} alt="documentresponse_icon" />
              <p>{text[0].fileName}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Location = ({ question, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{question.question}</div>
      </div>
      {console.log(question.answer)}
      <div
        className="table-view_shortAnswer"
        style={{ display: "flex", gap: "0.5rem" }}
      >
        {question.answer.map((answer, index) => (
          <div className="">{answer.value},</div>
        ))}
      </div>
    </div>
  );
};
export {
  ShortAnswer,
  ParagraphAnswer,
  Name,
  Phone,
  MultipleChoice,
  CheckBox,
  Email,
  Number,
  DateQuestion,
  LineScale,
  GridBox,
  CheckBoxGrid,
  DateAndTime,
  Website,
  Spinner,
  Dropdown,
  Signature,
  VAFileUpload,
  Document,
  Location,
};
